import { render, staticRenderFns } from "./prescription-card.vue?vue&type=template&id=195b76d4"
import script from "./prescription-card.vue?vue&type=script&lang=js"
export * from "./prescription-card.vue?vue&type=script&lang=js"
import style0 from "./prescription-card.vue?vue&type=style&index=0&id=195b76d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports